import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';

// Local preset identity until Genesis defines a schema-backed Core tree resource type.
export const TYPE_CORE_TREE = 'TYPE-CORE_TREE' satisfies ResourceTypeHandle;

export const RESOURCE_TYPE_REQUIREMENTS = [] as const satisfies readonly ResourceTypeHandle[];
